const styles = {
  header: {
    position: 'fixed',
    width: '100%'
  },
  headerMenu: {
    lineHeight: '64px'
  },
  logoContainer: {
    width: 120,
    height: 31,
    background: 'rgba(255, 255, 255, .2)',
    margin: '16px 24px 16px 0',
    float: 'left',
    textAlign: 'center',
    cursor: 'pointer'
  },
  logoText: {
    color: 'white',
    fontWeight: 'bold',
    marginTop: -16,
    display: 'block'
  }
}

export default styles;



// WEBPACK FOOTER //
// ./src/components/styles/Header.js